var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalDelegation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2392_13414",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2392_13414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2334 14.7327L12.5154 10.0147L13.4667 9.09675L17.2334 12.8634L24.8001 5.33008L25.7181 6.24808L17.2334 14.7327ZM8.53841 24.8711L18.6257 27.8147L26.6104 25.3481C26.5846 24.943 26.462 24.6511 26.2424 24.4724C26.0226 24.2937 25.7794 24.2044 25.5127 24.2044H19.1897C18.624 24.2044 18.1121 24.1822 17.6541 24.1377C17.1959 24.0933 16.7265 23.9874 16.2461 23.8201L13.3257 22.8634L13.7771 21.5454L16.4771 22.5224C16.9062 22.6849 17.3933 22.7823 17.9384 22.8147C18.4837 22.8472 19.2307 22.866 20.1794 22.8711C20.1794 22.4557 20.103 22.1199 19.9501 21.8634C19.7972 21.607 19.578 21.4284 19.2924 21.3277L11.6207 18.5121C11.5694 18.4952 11.5223 18.4824 11.4794 18.4737C11.4367 18.4653 11.3897 18.4611 11.3384 18.4611H8.53841V24.8711ZM3.20508 27.9994V17.1277H11.3127C11.4343 17.1277 11.56 17.1401 11.6897 17.1647C11.8197 17.1896 11.9429 17.2243 12.0591 17.2687L19.7641 20.0917C20.241 20.2729 20.6516 20.5985 20.9961 21.0687C21.3405 21.5387 21.5127 22.1395 21.5127 22.8711H25.5127C26.3163 22.8711 26.9317 23.1224 27.3591 23.6251C27.7864 24.1275 28.0001 24.7651 28.0001 25.5377V26.3584L18.6924 29.2301L8.53841 26.2711V27.9994H3.20508ZM4.53841 26.6661H7.20508V18.4611H4.53841V26.6661Z",
    fill: "#767676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalDelegation);
export default __webpack_public_path__ + "static/media/ApprovalDelegation.60149548fdb9806211a2f47c9226d7f1.svg";
export { ForwardRef as ReactComponent };